// extracted by mini-css-extract-plugin
export default {"container":"BetReviewed_container__j-E66"};